import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme) => ({
    form: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        minHeight: 'calc(100% - 60px)'
    },
    itemList: {
        overflowX: 'hidden',
        height: '100%',
        marginTop: 10
    },
    taxRow: {
        marginBottom: theme.spacing(2)
    },
    innerInputField: {
        paddingTop: 18.5,
        paddingBottom: 18.5
    },
    descriptionHelperText: {
        textAlign: 'right',
        marginBottom: theme.spacing(-2)
    },
    itemWrap: { marginBottom: 25 },
    lineItem: {
        display: 'flex',
        width: '100%'
    },
    deleteItem: {
        display: 'flex',
        marginBottom: 10
    },
    inputWrap: {
        width: '100%'
    },
    inputField: {
        marginBottom: 10
    },
    icon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    deleteWrap: {
        width: 45,
        marginTop: 6
    },
    iconGridRoot: {
        marginTop: theme.spacing(1)
    }
}));
